export default "__VITE_ASSET__11d08eef__"